<template>
  <div class="container-fluid p-0">
    
    <div v-if="!chatVisible" class="chat-bubble" @click="handleButtonClick">
      <button class="image-button">
        <img class="image" src="@/assets/img/Ingenierito.png" alt="Ingenierito" />
      </button>
    </div>
    
    <div v-if="!chatVisible" class="help-bubble">
      <p>Hola, ¿Necesitas ayuda?</p>
    </div>

    <div 
      v-show="chatVisible" 
      class="mb-3 px-0 bg-white" 
      style="border-radius: 20px; margin-top: 40px; margin-right: 10px;"
    >
      <div class="chat-container">
        
        <div class="header">
          <div class="header-icons">
            <div class="header-icons_title">CHAT</div>
            <div class="header-icons_img">
              <div class="icon"><img src="@/assets/img/expandir.png" alt="expandir" /></div>
              <div class="icon"><img src="@/assets/img/pantalla.png" alt="pantalla" /></div>
              
              <div class="icon icon-historial" @click.stop="toggleContext" ref="menuTrigger">
                <img src="@/assets/img/historial.png" alt="historial" />
              </div>
              
              <div v-if="contextVisible" class="chat-context" ref="menuDropdown">
                <button class="context-button" @click="handleActionNewChat">Nuevo chat</button>
                <button class="context-button" @click="toggleHistory">Historial</button>
              </div>

              <div class="icon icon-cerrar" @click="toggleChat">
                <img src="@/assets/img/close.png" alt="cerrar" />
              </div>
            </div>
          </div>
        </div>

        <div class="main">
          <div class="main-logo">
            <div class="logo"><img src="@/assets/img/Ingenierito.png" alt="logo" /></div>
            <div class="title">
              <p>¡Hola! Soy</p>
              <h1>IPSSOBOT</h1>
              <p>¿Cómo te puedo ayudar?</p>
            </div>
          </div>

          <div class="main-options">
            <button class="option option-matriz-iperc" @click="changeComponent('MatrizIperc')" :class="{ 'selected': currentComponent === 'MatrizIperc' }">Matriz IPERC</button>
            <button class="option option-chat-bot" @click="changeComponent('DefaultChat')" :class="{ 'selected': currentComponent === 'DefaultChat' }">ChatBot</button>
          </div>

          <div>
            <keep-alive><MatrizIperc v-if="currentComponent === 'MatrizIperc'" /></keep-alive>
            <keep-alive><DefaultChat v-if="currentComponent === 'DefaultChat'" :messages="chatMessages" :loading="loading" /></keep-alive>
          </div>
        </div>

        <div class="footer">
          <div class="mensaje">
            <form @submit.prevent="handleSubmit">
              <input type="text" v-model="prompt" placeholder="Preguntame cualquier cosa..." />
              <input type="hidden" v-model="selectedConversationId" />
              <button class="send-button" type="submit"><img class="imagen" src="@/assets/img/send.png" alt="send" /></button>
            </form>
          </div>
          <div class="options">
            <div class="img file-icon" @click="toggleIconContainer"><img src="@/assets/img/attach_file.png" alt="file" /></div>
            <div class="icon-container" :style="{ display: showIconContainer ? 'flex' : 'none' }">
              <div class="img-icon"><img src="@/assets/img/imagesmode.png" alt="image" /></div>
              <div class="img-icon"><img src="@/assets/img/location_on.png" alt="location" /></div>
              <div class="img-icon"><img src="@/assets/img/description.png" alt="document" /></div>
              <div class="img-icon"><img src="@/assets/img/account_box.png" alt="contacts" /></div>
              <div class="rombo"></div>
            </div>
            <div class="img"><img src="@/assets/img/photo_camera.png" alt="camera" /></div>
            <div class="img"><img src="@/assets/img/mic.png" alt="microfono" /></div>
          </div>
        </div>

        <div class="history-panel" :class="{ 'expanded': historyExpanded }">
            <button class="close-history" @click="toggleHistory">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.34923 5.11675C7.58272 5.35112 7.71387 5.66883 7.71387 6.00008C7.71387 6.33133 7.58272 6.64904 7.34923 6.88342L2.64792 11.5984C2.41403 11.8328 2.09684 11.9644 1.76613 11.9644C1.60239 11.9643 1.44025 11.9319 1.28898 11.8691C1.13771 11.8062 1.00028 11.7141 0.884517 11.598C0.768757 11.4819 0.676942 11.3441 0.614314 11.1924C0.551686 11.0407 0.519472 10.8781 0.51951 10.714C0.519549 10.5498 0.55184 10.3872 0.614539 10.2356C0.677238 10.0839 0.769118 9.94614 0.884932 9.83008L4.70516 6.00008L0.884932 2.17008C0.765796 2.05483 0.670748 1.91694 0.605333 1.76447C0.539918 1.612 0.505447 1.44799 0.503931 1.28201C0.502415 1.11604 0.533884 0.951428 0.596502 0.797779C0.659121 0.64413 0.751635 0.504522 0.868645 0.387101C0.985656 0.269681 1.12482 0.176799 1.27802 0.113875C1.43122 0.050952 1.59538 0.0192471 1.76093 0.0206108C1.92648 0.0219746 2.0901 0.0563784 2.24225 0.121817C2.3944 0.187255 2.53202 0.282416 2.64709 0.401749L7.3509 5.11675H7.34923Z" fill="#F8BC02" />
              </svg>
              <h2>Historial</h2>
            </button>

            <div class="chat-conversations modern-list" v-if="chatConversations !== null && chatConversations.length > 0">
              <div 
                v-for="(conversation, index) in chatConversations" 
                :key="index"
                class="history-card-btn"
                :class="{ 'active': selectedHistoryConversationId === (conversation.conversationId || conversation.id) }"
                @click="loadConversationToChat(conversation)"
              >
                <div class="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                </div>
                <div class="card-info">
                  <span class="card-title">Conversación #{{ conversation.conversationId || conversation.id }}</span>
                  <span class="card-date">{{ (conversation.messages && conversation.messages.length > 0) ? conversation.messages[conversation.messages.length - 1].time : 'Reciente' }}</span>
                </div>
                <div class="card-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </div>
              </div>
            </div>
            <div v-else class="empty-state">
              <p>No tienes historial disponible.</p>
            </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import { defineComponent } from "vue";
import MatrizIperc from "./MatrizIperc.vue";
import DefaultChat from "./DefaultChat.vue";
import moment from "moment";
export default defineComponent({
  name: "ChatBox",
  components: {
    MatrizIperc,
    DefaultChat,
  },
  data() {
    return {
      currentComponent: "DefaultChat",
      showIconContainer: false,
      selectedConversationId: null,
      chatVisible: false,
      informationVisible: false,
      contextVisible: false,
      prompt: "",
      chatMessages: [],
      chatConversations: [],
      loading: false,
      request: null,
      historyExpanded: false,
      selectedHistoryConversationId: null,
    };
  },

  mounted() {
    // Cuando el componente nace, empezamos a escuchar clicks en toda la pantalla
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // Cuando el componente muere, dejamos de escuchar para no causar errores
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    changeComponent(componentName) {
      this.currentComponent = componentName;
    },
    toggleIconContainer() {
      this.showIconContainer = !this.showIconContainer;
    },
    toggleChat() {
      this.chatVisible = !this.chatVisible;
    },
    toggleChatVisibility() {
      this.chatVisible = true;
    },
    handleButtonClick() {
      this.toggleChat(); 
      
      if (this.chatVisible && !this.selectedConversationId) {
        this.startNewChat();
      }
    },
    toggleInformation() {
      this.informationVisible = !this.informationVisible;
    },
    toggleContext() {
      this.contextVisible = !this.contextVisible;
    },
    startNewChat() {
      // 1. Limpiamos el ID seleccionado (null significa que aún no existe en BD)
      this.selectedConversationId = null;

      // 2. Reseteamos los mensajes visualmente con el saludo por defecto
      this.chatMessages = [{
        from: 'bot',
        text: '¡Hola! Soy Ipssobot, te ayudaré en todas las dudas que tengas sobre los cursos, diplomas, exámenes, y más. Dime, ¿Cuál es tu consulta?',
        time: moment().format('hh:mm A')
      }];
      
      // NOTA: No agregamos nada a chatConversations todavía. 
      // Se agregará automáticamente cuando el usuario envíe su primer mensaje.
    },
    async handleSubmit() {
      if (!this.prompt.trim()) return; // Validación simple de campo vacío

      // 1. Agrega el mensaje del usuario visualmente
      const userMessage = { text: this.prompt, from: 'user', time: moment().format('hh:mm A') };
      this.chatMessages.push(userMessage);
      
      // Guardamos el prompt y limpiamos el input para mejorar UX inmediata
      const currentPrompt = this.prompt;
      this.prompt = "";
      this.loading = true;

      try {
        // --- LÓGICA DE CREACIÓN PEREZOSA ---
        
        // Si NO hay ID de conversación, significa que es la primera interacción
        if (!this.selectedConversationId) {
            // 1. Creamos la conversación en BD primero
            const createResponse = await this.$axios.post(`/chatbot/createConversation`, {}, {
                headers: { Authorization: '' },
                withCredentials: false
            });
            
            // 2. Asignamos el nuevo ID
            this.selectedConversationId = createResponse.data.id;

            // 3. (Opcional) Lo agregamos a la lista local de historiales para que aparezca si abres el menú
            // Verificamos si chatConversations está inicializado
            if (!this.chatConversations) this.chatConversations = [];
            
            this.chatConversations.unshift({
                id: this.selectedConversationId,
                conversationId: this.selectedConversationId,
                messages: [this.chatMessages[0]] // Guardamos con el mensaje inicial
            });
        }

        // --- FIN LÓGICA CREACIÓN PEREZOSA ---

        // 2. Ahora sí enviamos el mensaje al chat con el ID confirmado
        this.request = await this.$axios.post(`/chatbot/chat`, {
          queryResult: currentPrompt,
          conversationId: this.selectedConversationId
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
          withCredentials: false
        });

        const response = await this.request;
        this.chatMessages.push({ text: response.data.response, from: 'bot', time: moment().format('hh:mm A') });
      }
      catch (err) {
        console.error('Error:', err);
        // Opcional: Agregar mensaje de error visual al chat
        this.chatMessages.push({ text: "Lo siento, hubo un error al procesar tu mensaje.", from: 'bot', time: moment().format('hh:mm A') });
      }
      finally {
        this.loading = false;
      }
    },

    toggleHistory() {
      this.contextVisible = false;
      
      this.$axios.get(`/chatbot/history`)
        .then((response) => {
          const rawHistory = response.data.allChatHistory;
          if (Array.isArray(rawHistory)) {
             this.chatConversations = rawHistory.filter(chat => {
                 // Verificamos si existe el array de mensajes y si tiene contenido
                 return chat.messages && chat.messages.length > 0;
             });
          } else {
             this.chatConversations = [];
          }
          
          this.historyExpanded = !this.historyExpanded;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    loadConversationToChat(conversation) {
      // 1. Obtener ID
      const conversationId = conversation.conversationId || conversation.id;
      this.selectedConversationId = conversationId;
      this.selectedHistoryConversationId = conversationId;

      console.log("Cargando chat ID:", conversationId);

      this.$axios.get(`/chatbot/history/${conversationId}`)
        .then((response) => {
          const chatHistory = response.data.chatHistory || response.data; 

          if (Array.isArray(chatHistory) && chatHistory.length > 0) {
            
            this.chatMessages = chatHistory.map(message => {
              let textoLimpio = "";
              
              // ESTRATEGIA 1: Buscar en la raíz (formato simple)
              if (message.content) textoLimpio = message.content;
              else if (message.text) textoLimpio = message.text;
              else if (message.response) textoLimpio = message.response;

              // ESTRATEGIA 2: Buscar en 'choices' (formato OpenAI)
              if (!textoLimpio && message.choices) {
                try {
                  // Si viene como string, lo parseamos. Si ya es objeto, lo usamos directo.
                  let choicesData = message.choices;
                  if (typeof choicesData === 'string') {
                     // Limpieza extra por si viene doblemente stringified
                     try { choicesData = JSON.parse(choicesData); } catch(e) { /* ignorar */ }
                  }

                  // Navegamos la estructura
                  if (Array.isArray(choicesData) && choicesData.length > 0) {
                    const item = choicesData[0];
                    if (item.message && item.message.content) {
                      textoLimpio = item.message.content; // Formato nuevo GPT
                    } else if (item.text) {
                      textoLimpio = item.text; // Formato antiguo
                    }
                  }
                } catch (e) {
                  console.warn("Error parseando choices:", e);
                }
              }

              if (!textoLimpio) {
                 console.log("Mensaje fallido raw:", message); 
                 textoLimpio = "RAW: " + (typeof message.choices === 'string' ? message.choices : JSON.stringify(message)); 
              }

              return {
                text: textoLimpio,
                from: (message.emisor === 'User' || message.role === 'user') ? 'user' : 'bot', 
                time: moment(message.date_of_issue).locale("es").fromNow(),
              };
            });

            // Cerrar menus
            this.historyExpanded = false;
            this.contextVisible = false;
            this.chatVisible = true;

          } else {
            this.chatMessages = [{
               from: 'bot',
               text: 'Esta conversación no tiene mensajes guardados.',
               time: moment().format('hh:mm A')
            }];
          }
        })
        .catch((error) => {
          console.error("Error cargando historial:", error);
        });
    },

    // Detecta si el clic fue fuera del menu
    handleClickOutside(event) {
      if (this.contextVisible) {
        const trigger = this.$refs.menuTrigger;
        const menu = this.$refs.menuDropdown;
        
        // Si el clic NO fue en el botón NI en el menú, cerramos el menú
        if (trigger && !trigger.contains(event.target) && menu && !menu.contains(event.target)) {
          this.contextVisible = false;
        }
      }
      
      // Lógica similar para el contenedor de adjuntar archivos (el clip)
      if (this.showIconContainer) {
        const fileIcon = this.$el.querySelector('.file-icon');
        const container = this.$el.querySelector('.icon-container');
        if (fileIcon && !fileIcon.contains(event.target) && container && !container.contains(event.target)) {
           this.showIconContainer = false;
        }
      }
    },

    // Función auxiliar para crear chat y cerrar el menú
    handleActionNewChat() {
      this.contextVisible = false; // Cierra el menú
      this.startNewChat(); // Inicia el chat
    },

  },

});
</script>
<style>
* {
  box-sizing: border-box;
}

.chat-bubble {
  position: absolute;
    bottom: 262px;
    right: 60px;
    width: 5.4375rem;
    height: 5.4375rem;
    flex-shrink: 0;
    border: 2px solid rgba(255, 233, 164, 0.98);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1000;
    box-shadow: 0px 4px 6px rgb(250, 213, 5);
    transition: background-color 0.3s ease;
}

.image {
  width: 6rem;
    /* height: 5.4375rem; */
    flex-shrink: 0;
    margin-left: 0px;
    object-fit: cover;
}

.image-button {
  border: none;
  /* Elimina el borde del botón */
  background: none;
  /* Elimina el fondo del botón */
  cursor: pointer;
  /* Cambia el cursor al pasar por encima del botón */
  padding: 0;
  /* Elimina el espacio interior del botón */
}

.help-bubble {
  position: absolute;
    bottom: 21rem;
    right: 139px;
    background-color: white;
    color: black;
    padding: 10px;
    border-radius: 10px 10px;
    cursor: pointer;
    z-index: 999;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

.help-bubble p {
  margin: 0;
}

.chat-container {
    /* --- ESTRUCTURA LIMPIA --- */
    width: 100%;       /* Llenar el contenedor padre (El gemelo del temario) */
    height: 756px;     /* Altura fija o automática, según prefieras */
    margin: 0;         /* Quitamos márgenes porque el padre ya tiene margin-top: 40px */
    right: 0;          /* Quitamos posicionamiento relativo */
    
    /* --- ESTÉTICA --- */
    background: #fff;
    border: 1px solid #f8bc02;
    border-radius: 20px; /* Coincide con el padre */
    position: relative; 
    overflow: hidden;
}
/* **************** */
.header {
  font-family: "Anek Latin", sans-serif;
}

.header .header-icons {
  position: relative;
  border-radius: 15px 15px 0px 0px;
  background: #f8bc02;
  display: flex;
  align-items: center;
  padding: 4px 20px;
  justify-content: space-between;
}

.header .header-icons_title {
  color: #ffffff;
  font-weight: 500;
  font-size: 20px;
  margin-left: 15px;
}

.header .header-icons_img {
  display: flex;
}

.header .header-icons_img .icon {
  margin: 10px 5px;
  cursor: pointer;
}

.header .header-icons_img .icon img {
  width: 17.44px;
  height: 17.44px;
}

.header .header-icons_img .icon-historial img {
  width: 4.98px;
  height: 18.69px;
}

.header .header-icons_img .icon-cerrar img {
  width: 18.96px;
  height: 16.96px;
}

/*fin del header*/
.main {
  height: auto;
  /* Establece la altura deseada */
  overflow-y: auto;
  /* Agrega una barra de desplazamiento vertical cuando sea necesario */
}

/* Estilos para la barra de desplazamiento en navegadores webkit (Google Chrome) */
.main::-webkit-scrollbar {
  width: 8px;
  /* Ancho de la barra de desplazamiento */
}

/* Estilos para el riel de la barra de desplazamiento en navegadores webkit (Google Chrome) */
.main::-webkit-scrollbar-track {
  background-color: #f8bc02;
  /* Color de fondo del riel */
  border-radius: 4px;
  /* Radio de borde del riel */
}

/* Estilos para el thumb (manija) de la barra de desplazamiento en navegadores webkit (Google Chrome) */
.main::-webkit-scrollbar-thumb {
  background-color: orange;
  /* Color del thumb */
  border-radius: 4px;
  /* Radio de borde del thumb */
}

/* Estilos para la barra de desplazamiento en Firefox */
.main {
  scrollbar-width: thin;
  /* Ancho del scrollbar */
}

/* Estilos para el thumb (manija) de la barra de desplazamiento en Firefox */
.main {
  scrollbar-color: #f8bc02 rgb(245, 231, 231);
  /* Color del thumb y del riel respectivamente */
  position: relative;
  height: 704.74px;
}

.main-logo {
  font-family: "Anek Latin", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.main-logo .logo img {
  width: 69.87px;
  height: 69.87px;
  margin-right: 10px;
}

.main-logo .title {
  line-height: 4px;
  text-align: justify;
  color: black;
  font-weight: 700;
}

.main-logo .title p {
  font-size: 12px;
}

.main-logo .title h1 {
  font-size: 25px;
}

/* opciones de chatbot */
.main-options {
  display: flex;
  margin: 10px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-weight: bold;
  margin-top: 20px;
}

.main-options .option {
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  align-items: center;
  background: #eeeeee;
  width: 108.39px;
  height: 52.32px;
  padding: 10px 50px;
  text-align: center;
  margin: 2px;
  border-radius: 10px;
  border: none;
  display: flex;
  justify-content: center;
  cursor: pointer;
  font-weight: 800;
  transition: background-color 0.3s;
}

.option.selected {
  background: #f8bc02;
  color: white;
  font-weight: 600;
}

/* Cambia el color al pasar el cursor */
.option:hover {
  background-color: #f8bc02;
  color: white;
  font-weight: 600;
}

/* Cambia el color cuando el botón está seleccionado */

.main-options .option:nth-child(2) {
  height: 54px;
}

.footer {
  font-family: "Anek Latin", sans-serif;
  background: #f8bc02;
  display: flex;
  justify-content: space-between;
  /*  padding: 0px 20px; */
  align-items: center;
  border-radius: 0px 0px 15px 15px;
  position: relative;
    bottom: 56px;
  right: 0px;
  width: 100%;
  height: 55.13px;
}

.footer .options {
  display: flex;
  cursor: pointer;
  margin: 0px 6px 0px -3px;
}

.footer .options .img {
  margin-left: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 27px;
  height: 27px;
}

.footer .options .img:hover {
  background: #bf9500;
  border-radius: 50%;
}

.footer .options img {
  width: 22.49px;
  height: 22.49px;
}

.footer .mensaje {
  display: flex;
  align-items: center;
  position: relative;
  width: 275px;
  margin: 0 auto;
}

.footer .mensaje input {
  width: 275px;
  height: 37.37px;
  padding: 0px 14px;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding-right: 40px;
  background-color: white;
}

.footer input:focus {
  outline: none;
}

.footer .mensaje ::placeholder {
  font-family: "Anek Latin", sans-serif;
  font-weight: 300;
  font-size: 15px;
  text-align: left;
  color: #b9b9b9;
}

.footer .mensaje img {
  position: absolute;
  cursor: pointer;
  left: 88%;
}

.footer .imagen {
  position: absolute;
  top: 50%;
  right: 10px;
  /* Posicionamiento a la derecha */
  transform: translateY(-50%);
  width: 20px;
  /* Ancho de la imagen */
  height: auto;
}

/* codigo nuevo */
/* Estilos para los iconos de opciones */
.footer .icon-container {
  position: absolute;
  bottom: 58px;
  background: rgb(191, 149, 0);
  height: 32.67px;
  width: 115px;
  right: 32px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer .icon-container img {
  width: 22.83px;
  height: 22.83px;
}

.rombo {
  background-color: transparent;
  position: absolute;
  top: 32px;
  left: 45px;
}

.rombo:after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 13px solid transparent;
}

.rombo:after {
  border-top-color: rgb(191, 149, 0);
}

.chat-context {
  position: absolute;
  top: 40px; 
  right: 50px; 
  width: 7.5625rem;
  height: auto; 
  padding: 5px 0;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  background: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  z-index: 10001; 
}

.chat-context button:hover {
  background-color: #f0f0f0;
}

.context-button {
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  /* Centramos el texto horizontalmente */
  padding: 5px;
  /* Ajustamos el relleno */
  color: #545454;
  font-family: "Anek Latin", sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.send-button {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
}

.history-panel {
    position: absolute;
    top: 0;
    right: -100%; 
    width: 250px; 
    height: 100%; 
    background-color: #fff;
    z-index: 999; 
    transition: right 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    display: flex;
    flex-direction: column;
}

/* Clase que activa el panel */
.history-panel.expanded {
  right: 0; /* Se desliza hacia adentro */
  visibility: visible;
}

/* Botón para cerrar  */
.close-history {
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  padding: 15px;
  cursor: pointer;
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
  margin: 0;
}

.close-history h2 {
    margin: 0;
    color: #f8bc02;
    font-size: 16px;
    font-family: "Anek Latin", sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    width: auto; 
    height: auto;
}

.chat-conversations.modern-list {
    padding: 10px;
    overflow-y: auto;
    flex: 1; 
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #ffffff;
    width: 100%; 
    max-width: none;
    max-height: none;
    border-radius: 0; 
}

.chat-conversations.modern-list::-webkit-scrollbar {
  width: 5px;
}
.chat-conversations.modern-list::-webkit-scrollbar-thumb {
  background-color: #e0e0e0;
  border-radius: 4px;
}

.history-card-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

/* Efecto Hover */
.history-card-btn:hover {
  transform: translateY(-2px);
  border-color: #f8bc02;
  box-shadow: 0 4px 8px rgba(248, 188, 2, 0.15);
}

/* Estado Activo */
.history-card-btn.active {
  background: #fffdf5;
  border-color: #f8bc02;
  border-left: 4px solid #f8bc02;
}

/* Icono Izquierdo */
.card-icon {
  background: #f5f5f5;
  color: #888;
  min-width: 30px;
  height: 30px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  transition: background 0.3s;
}

.history-card-btn:hover .card-icon {
  background: #f8bc02;
  color: white;
}

/* Textos */
.card-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-title {
  font-family: "Anek Latin", sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-date {
  font-family: "Anek Latin", sans-serif;
  font-size: 10px;
  color: #999;
  margin-top: 2px;
}

/* Flecha Derecha */
.card-arrow {
  color: #ccc;
  opacity: 0;
  transform: translateX(-5px);
  transition: all 0.3s ease;
}

.history-card-btn:hover .card-arrow {
  opacity: 1;
  transform: translateX(0);
  color: #f8bc02;
}

/* Estado Vacío */
.empty-state {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
}
</style>
